import { render, staticRenderFns } from "./TourCard.vue?vue&type=template&id=64ebb1e3"
import script from "./TourCard.vue?vue&type=script&lang=js"
export * from "./TourCard.vue?vue&type=script&lang=js"
import style0 from "./TourCard.vue?vue&type=style&index=0&id=64ebb1e3&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ebb1e3')) {
      api.createRecord('64ebb1e3', component.options)
    } else {
      api.reload('64ebb1e3', component.options)
    }
    module.hot.accept("./TourCard.vue?vue&type=template&id=64ebb1e3", function () {
      api.rerender('64ebb1e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TourCard.vue"
export default component.exports